import EntityListContainer from './EntityListContainer'
import EntityDetail from './EntityDetail'
import ACLService from 'Services/ACL_Service'
import { setAclFunctions } from './AclDataProvider/actions'
import { Key } from 'react-feather'
import { Roles, Users } from './DetailPanels'

getUsers = (acl) ->
  Promise.filter(await Weaver.User.list(), (user) ->
    getPermissions(acl, user)
  )

getPermissions = (acl, user) ->
  roles = await user.getRoles()

  user.hasRoleReadAccess = roles.map((role) ->
    acl.getRoleReadAccess(role)
  ).some((canRead)-> canRead)

  user.hasRoleWriteAccess = roles.map((role) ->
    acl.getRoleWriteAccess(role)
  ).some((canWrite)-> canWrite)

  user.hasWriteAccess = acl.getUserWriteAccess(user) or user.hasRoleWriteAccess
  user.cannotChangePermissions = user.hasRoleWriteAccess
  user.cannotRevoke = user.hasRoleReadAccess

  user.hasRoleReadAccess or acl.getUserReadAccess(user)

addUser = (acl, user) ->
  acl.setUserReadAccess(user, true)
  await acl.save()
  await getPermissions(acl, user)
  user

removeUser = (acl, user) ->
  acl.setUserReadAccess(user, false)
  acl.setUserWriteAccess(user, false)
  acl.save()

setUserWriteAccess = (acl, user, canWrite) ->
  acl.setUserWriteAccess(user, canWrite)
  acl.save()

getRoles = (acl) ->
  (await Weaver.Role.list()).filter((role) ->
    role.hasWriteAccess = acl.getRoleWriteAccess(role)
    acl.getRoleReadAccess(role)
  )

addRole = (acl, role) ->
  acl.setRoleReadAccess(role, true)
  await acl.save()
  role

removeRole = (acl, role) ->
  acl.setRoleReadAccess(role, false)
  acl.setRoleWriteAccess(role, false)
  acl.save()

setRoleWriteAccess = (acl, role, canWrite) ->
  acl.setRoleWriteAccess(role, canWrite)
  acl.save()

export DetailView = EntityDetail({
  title: (acl) -> acl.id()
  icon: 'key'
  getItem: (id) ->
    (await Weaver.ACL.list()).find((acl) ->
      acl.id() is id
    )
  tabs: [{
    title: 'Granted Users'
    Component: Users({ getUsers, addUser, removeUser, setWriteAccess: setUserWriteAccess })
  }, {
    title: 'Granted User Groups'
    Component: Roles({ getRoles, addRole, removeRole, setWriteAccess: setRoleWriteAccess })
  }]
})

export ListView = EntityListContainer({
  title: 'Global permissions'
  singular: 'function'
  singularRoute: 'permissions'
  Icon: Key
  canCreate: false
  canDelete: false
  init: ->
    acls = _.sortBy(await ACLService.loadFunctionAcls(), 'id')
    setAclFunctions(acls)
  reducerKey: 'aclFunctions'
  filterer: (str) -> (item) -> item.id().toLowerCase().includes(str.toLowerCase())
  itemProps: {
    title: (item) -> item.id()
    key: (item) -> item.id()
  }
})
